import { render, staticRenderFns } from "./details.vue?vue&type=template&id=ba033bea&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=ba033bea&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba033bea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba033bea')) {
      api.createRecord('ba033bea', component.options)
    } else {
      api.reload('ba033bea', component.options)
    }
    module.hot.accept("./details.vue?vue&type=template&id=ba033bea&scoped=true", function () {
      api.rerender('ba033bea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goodsManage/edit/details.vue"
export default component.exports